import { DecoderHelpers } from '@headless-workspace/utils';
import { z } from 'zod';
import { ScheduleDTO } from './ScheduleDTO';

export const StoreInfoDTO = z.object({
    id: z.string(),
    name: z.string(),
    address1: z.string(),
    postalCode: z.string(),
    city: z.string(),
    phone: z.string(),
    countryCode: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    schedule: z.array(ScheduleDTO),
    distance: z.number().optional(),
    distanceText: z.string().optional(),
    exceptionalOpeningDays: z
        .object({
            schedule: z.array(ScheduleDTO).default([]),
            exceptionalOpeningDaysText: z.string().optional(),
        })
        .optional(),
    exceptionalClosingDays: z
        .object({
            days: z.array(z.string()).default([]),
            exceptionalClosingDaysText: z.string().optional(),
        })
        .optional(),
    services: z
        .array(
            z.object({
                id: z.string(),
                name: z.string(),
            }),
        )
        .default([]),
    deliveryOptions: z
        .object({
            clickAndCollect: z.boolean().nullish(),
            deliveryToStore: z.boolean().nullish(),
        })
        .nullish(),
    products: DecoderHelpers.defaultArray(
        z.object({
            id: z.string(),
            isAvailable: z.boolean().nullish(),
            isBonus: z.boolean().nullish(),
            stock: z.number().nullish(),
        }),
    ),
});

export type StoreInfoDTO = z.infer<typeof StoreInfoDTO>;

export const StoreInfoListDTO = z.object({ stores: z.array(StoreInfoDTO) });
